module.exports = __webpack_public_path__ + "static/media/icon-download.de1fd164.svg";